<template>
<div class="dashboard-side-nav-wrapper">
    <div class="dashboard-side-nav" :class="{'nav-expanded': navExpanded}">
        <div class="dashboard-menu-header sidebar-switch" @click="expandSidebar()">
            <i class="burger"></i>
        </div>

        <div class="dashboard-menu smallscroll" role="navigation">       
        <ul class="navigation">

            <li v-for="action in actions" :key="action.id" class="menu-item active root-item" :class="{'open': action.open}">
                  <a v-on:mouseover.self="setHintPos($event)" :title="action.hint" @click.prevent="action.func($event, action.module); expandNode($event, action)"><i class="menu-icon fa" :class="action.icon"></i>
                  <span>{{action.title}}</span><b class="hint">{{action.hint}}</b></a>

                    <ul v-if="action.actions.length > 0">
                        <li v-for="action in action.actions" :key="action.id" class="menu-item">
                            <a v-on:mouseover.self="setHintPos($event)" :title="action.hint" @click.prevent="action.func($event, action.module)"><i class="menu-icon fa" :class="action.icon"></i>
                            <span>{{action.title}}</span><b class="hint">{{action.hint}}</b></a>
                        </li>
                    </ul>

            </li>

        </ul>
        </div>
                        
        <div class="dashboard-menu-footer"><a>{{nav_action}}</a></div>
    </div>
</div>
</template>


<script>
export default {
    name: 'sidebar',
    template: '<sidebar/>',
    data () {
        return {
            nav_action: 'root',
            nav_expanded: true,    
            actions: [
                {id:1, icon:'fa-briefcase', open:true, title:'Рабочий стол', hint: 'hint', module:"root", func:this.onAction, actions:[
                    {id:1, icon:'fa-list', title:'Проекты', hint: 'hint', module:"listProjects", func:this.onAction },
                    {id:2, icon:'fa-list', title:'Шаблоны', hint: 'hint', module:"listTemplates", func:this.onAction },
                    {id:3, icon:'fa-plus', title:'Создать новый', hint: 'hint', module:"projectCreate", func:this.onAction }

                ]},
                {id:2, icon:'fa-plus', open:true, open:false, title:'Контрагенты', hint: 'hint', module:"listContragents", func:this.onAction, actions:[
                    {id:1, icon:'fa-list', title:'Подрядчики', hint: 'hint', module:"listWorkers", func:this.onAction },
                    {id:2, icon:'fa-list', title:'Заказчики', hint: 'hint', module:"listClients", func:this.onAction },
                    {id:3, icon:'fa-plus', title:'Добавить', hint: 'hint', module:"addAgent", func:this.onAction }
                ]},
                {id:3, icon:'fa-plus', open:true, open:false, title:'Мой аккаунт', hint: 'hint', module:"account", func:this.onAction, actions:[
                    {id:1, icon:'fa-plus', title:'Тариф', hint: 'hint', module:"configPlan", func:this.onAction },
                    {id:2, icon:'fa-plus', title:'безопасность', hint: 'hint', module:"configSecurity", func:this.toggleFullscreen }
                ]},

            ]
        }
    },

    computed: {
        navExpanded(){
            return this.nav_expanded
        },
        currentView(){
            return this.nav_action
        }
    },

    methods: {
        toggleFullscreen(event) {
            var element = event.documentElement || document.body ;
        	if (event instanceof HTMLElement) { element = event; }
	        var isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;
        	element.requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || function () { return false; };
	        document.cancelFullScreen = document.cancelFullScreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || function () { return false; };
        	isFullscreen ? document.cancelFullScreen() : element.requestFullScreen();
        },                
        
        setHintPos(e){
            //console.dir(e.target.offsetTop);
            //console.dir(e.target.lastChild.style);//.top = e.target.offsetTop);
            let parentRect = e.target.getBoundingClientRect();
            let hintRect = e.target.lastChild.getBoundingClientRect();
            
            //{для релативного блока}
            //let win = e.target.ownerDocument.defaultView;
            //let offset = win.pageYOffset;            
            //let y = math.round(parentRect.top + offset) + math.round(parentRect.height / 2);
            
            //{для фиксированого с прокруткой по Y}        
            let y = math.round(parentRect.top) + math.round(parentRect.height / 2);

            //console.log(hintRect.height);
            //console.dir(e.target.getBoundingClientRect());
            e.target.lastChild.style.top = y + 'px'; //e.target.offsetTop +'px';
            //console.dir(e.target.top);
            //e.target.lastChild.top = e.target.top;
        },
        resetHintPos(e){
            let parentRect = e.target.getBoundingClientRect();
            let hintRect = e.target.lastChild.getBoundingClientRect();
            let y = math.round(parentRect.top) + math.round(parentRect.height / 2);
            e.target.lastChild.style.top = y + 'px'; 
        },
        
        recalcHintPositions(node){
            let rootItems = this.$el.querySelectorAll('.root-item');
            rootItems.forEach( function(rootItem, idx) { 
                let rootRect = rootItem.getBoundingClientRect();
                var y = math.round(rootRect.top) + math.round(rootRect.height / 2);
                let menuTreeItems = rootItem.querySelectorAll('.menu-item');
                menuTreeItems.forEach( function(menuItem, idx) { 
                    //console.dir(menuItem);
                    //console.dir(menuItem.getBoundingClientRect());
                    var itemRect = menuItem.getBoundingClientRect();
                    if (itemRect.height > 0) { y = math.round(itemRect.top) + math.round(itemRect.height / 2); }
                    let hint = menuItem.querySelector('.hint');    
                    if (hint) {
                        //console.log(y);
                        hint.style.top = y + 'px';
                    }
                });
            });
        },

        expandSidebar(){
            //console.dir(this.$el);
            this.nav_expanded = this.nav_expanded ? false : true;
            document.body.classList.toggle('nav-expanded');
            this.recalcHintPositions();
        },
        expandNode(e,action){
            //action                                    
//            if (e.target.parentNode.tagName === 'LI') {
//                 e.target.parentNode.classList.toggle('open'); 
//            } else {e.target.parentNode.parentNode.classList.toggle('open'); }
            //console.log('expand ' + e.target);
            //console.dir(action);
            //if ((action.open) && (this.currentView == action.module)) return false;
            action.open = action.open ? false : true;
            this.recalcHintPositions();
            //if (action.open != 'open') {   action.open = 'open';   } else {action.open = '' }
        },
        onAction(e, module){
            let mod = module != 'undefined' ? module : 'root';
            this.nav_action = module;
            this.$parent.setView(module);
            //console.dir(e);
            //console.log(module);
        },
    },

    created(){
        
    },

    mounted(){
        if (this.nav_expanded) {
            //this.$el.classList.add('.nav-expanded')
            document.body.classList.add('nav-expanded')
        };
        this.recalcHintPositions();        
    }

}
</script>



<style lang="scss">
  

$menu-bg-color: #383d43;
$menu-link-color: #ddd;
$menu-link-hover-color: lighten(#ddd, 30%);
$menu-width-collapsed: 6rem;
$menu-width: 220px;

$icon-color: rgb(102, 143, 102);

/* lighten()
$lighter: lighten($color,30%);
$darker: darken($color,30%);
 */

.dashboard-side-nav-wrapper{
    flex: 0 0 $menu-width;
}

.dashboard-menu-header{
    display: flex;
    justify-content: center;
    padding: 1rem;
    border-bottom: 1px solid rgba(0,0,0, 0.2);
}

.dashboard-menu-header .burger{
    font-size: 24px;
    font-family: "Font Awesome\ 5 Free";
    font-weight: 900;
    transition: all .2s ease-in-out;
    
    cursor: pointer;
}

.burger::after{content: '\f0c9'; font-style: normal;}
.nav-expanded .burger::after{content: '\f00d';}
.nav-expanded  .dashboard-menu-header .burger{
    transform: rotate(90deg)
}

.dashboard-side-nav { 
  display: flex;
  flex-direction: column;
  align-items: stretch;  
  align-content: space-between;

  background-color: $menu-bg-color;
  user-select: none;
  height: 100vh;
  position: fixed;
  color: #fff;
}


.dashboard-menu {
  display: flex;   
  flex-direction: column;
  height: calc(100% - 1rem);
  margin: 0;
  overflow-y: auto;
  overflow-x: hidden;     
  
  color: #ccc;
  font-size: 12px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;  
  
  border-radius: 3px;
  /* justify-content: stretch;
  align-items: stretch;
  align-content: stretch;    */
}

.dashboard-menu, .dashboard-menu-footer{
  width: $menu-width-collapsed;   
  transition: all .2s ease-in-out;
}

.nav-expanded .dashboard-menu, 
.nav-expanded .dashboard-menu-footer{
  width: $menu-width;
  transition: all .1s ease-in-out;
}

.dashboard-menu a span{
    opacity: 0;   
    white-space: nowrap;
    transition: all .4s ease-in-out;
}
.nav-expanded .dashboard-menu a span{
    opacity: .99;
    transition: all .4s ease-in-out;
}

.dashboard-menu a {
    color: $menu-link-color;
}
.dashboard-menu a:hover {
    color: $menu-link-hover-color;
}

.dashboard-menu ul{
    display: flex;
    align-content: stretch;
    align-items: stretch;
    justify-items: stretch;
    justify-content: stretch;
    flex-direction: column;    
}

.dashboard-menu ul, .dashboard-menu ul li {    
 }

.dashboard-menu ul li a{
  border-bottom: 1px solid rgba(0,0,0,.1)
}

.dashboard-menu ul li a:hover{
  background-color: #3c4249;
}



.dashboard-menu ul li a{
  display: flex;
  align-items: center;
}

  .dashboard-menu ul li a {       
    padding: .4rem .7rem .4rem 1rem;
    border-left: 4px solid rgba(0,0,0, 0);   
    /*display: inline-flex; */
    align-items: baseline;
      display: flex;
  align-items: center;
  }
  
  .dashboard-menu .menu-icon{
    /* color: mediumseagreen; */
    color: $icon-color;
    font-family: "Font Awesome\ 5 Free";
    font-weight: 900;
  }


.dashboard-menu .root-item>a{
  font-weight: 900;
}


.dashboard-menu .root-item>a::after {
    content: "\f105";
    /* display: block; */
    font-family: 'Font Awesome\ 5 Free';
    font-weight: 900;
    /* position: absolute; */
    text-align: center;
    transform-origin: center center;
    transition: all .1s ease-in-out;
    margin-left: auto;
    right: 1rem;
    font-size: 10px;
    margin-left: auto;
    flex-basis: 10px;
    flex-flow: 0;

  }


.dashboard-menu .root-item.open>a::after{
    transform: translateZ(0) rotate(90deg);
  }

  .dashboard-menu .root-item>ul{
    display: none;
    animation: toggle .2s ease-in-out; 
  }

  .dashboard-menu .root-item.open>ul{    
    display: block; 
  }

.dashboard-menu ul li a span{
 padding: .4rem 0rem .4rem 1rem; 
}

.dashboard-menu li a .hint{  
  /*visibility: hidden; */
  display: inline-flex;
  align-items: center;
  position: absolute; 

  text-shadow: 0px 1px 0px rgba(0,0,0, 0.5);
  border: 1px solid #62606d;

  border-radius: 3px;
  background: rgb(58, 57, 68);
  padding: 4px 8px 4px 8px;  
  opacity: 0;  
  transform: scale(.1) translateZ(0);
  /*transition: all .2s ease-in-out; */
  //transition: opacity transform left  .4s cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1); 
  /*transition: right 1.4s, scale .2s, opacity .2s, transform .2s; */
  transition: right .4s, scale .2s, opacity .3s, transform .2s;
  transition-delay: 0s; 
  white-space: nowrap;
  z-index: 222;
  transform-origin: left center;
  font-size: 10px;
  font-weight: 500;
  line-height: 22px;  
  height: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;  
  margin-top: -11px;
  pointer-events: none;  
  right: -3rem;  

  color: rgba(255,255,255,0.87);
    background-color: rgba(46,58,77,0.9);

}
.dashboard-menu li a:hover .hint{
  visibility: visible;
  right: -3.5rem;  
  opacity: .8;
  transform: scale(1);
  transition-delay: .2s; 
  
}


.dashboard-menu-footer{
/*  margin-top: auto; */
  padding: 1rem;
  border-top: 1px solid #222;
}  


/*
element.style {
    top: 359px;
    /* left: 68px; */
    /* pointer-events: all; */
    /* z-index: 101; 
}
*/

/*
.md-panel.md-tooltip.md-gmp-blue-theme {
    color: rgba(255,255,255,0.87);
    background-color: rgb(97,97,97);
}
.md-tooltip.md-show {
    -webkit-transition: all .4s cubic-bezier(0.25,0.8,0.25,1);
    transition: all .4s cubic-bezier(0.25,0.8,0.25,1);
    -webkit-transition-duration: 150ms;
    transition-duration: 150ms;
    -webkit-transform: scale(1);
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: .9;
}
md-tooltip, .mat-tooltip {
    background-color: rgba(46,58,77,0.9)!important;
}
@media (min-width: 960px)
.md-tooltip.md-origin-right {
    margin-left: 14px;
}
.md-tooltip.md-origin-right {
    -webkit-transform-origin: left center;
    -webkit-transform-origin: left center;
    transform-origin: left center;
    margin-left: 24px;
}

@media (min-width: 960px)
.md-tooltip {
    font-size: 10px;
    height: 22px;
    line-height: 22px;
    padding-right: 8px;
    padding-left: 8px;
}
.md-tooltip {
    pointer-events: none;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    overflow: hidden;
    opacity: 0;
    font-weight: 500;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 32px;
    line-height: 32px;
    padding-right: 16px;
    padding-left: 16px;


<div class="md-panel-outer-wrapper md-gmp-blue-theme md-panel-is-showing" style="pointer-events: none; z-index: 100;">
<md-tooltip class="c5e-nav-tooltip md-origin-right md-panel md-tooltip md-gmp-blue-theme md-show" md-delay="0" md-direction="right"
 tabindex="-1" style="top: 359px; left: 68px; pointer-events: all; z-index: 101;" role="tooltip"> AdMob </md-tooltip></div>


*/

.smallscroll::-webkit-scrollbar-track
{ 
  box-shadow: inset 0 0 2px rgba(0,0,0, 0.3); 
	border-radius: 2px;
  background-color: #888;
  
}

.smallscroll::-webkit-scrollbar-thumb:hover{
  background-color: #333;  
}

.smallscroll::-webkit-scrollbar
{
	width: 8px;
	border-radius: 2px;
  background-color: #888;  
}

.smallscroll::-webkit-scrollbar-thumb
{
  width: 2px;
  border-radius: 2px;
  background-color: #444;
  border: 2px solid #888;
}

</style>
